export default {
  heroTitle1: 'Saving Mode',
  heroTitle2: 'Spar på opladning',
  heroSubtitle: 'Prisgaranti på opladning – du betaler altid for de billigste timer i din ladeperiode. Inkluderet for alle kunder med en elaftale.',
  freeForCustomers: 'Inkluderet i din elaftale.',
  seeChargingSolutions: 'Se ladeløsninger',

  // AI banner
  aiBannerTitle: 'Prisgaranti på opladning',
  aiBannerSubtitle: 'Du betaler altid for de billigste timer i din ladeperiode, og din bil er altid klar når du skal bruge den',
  aiBannerNote: 'Helt automatisk – du slipper for at planlægge opladningen selv',

  // What is section
  whatIsTitle: 'Hvad er enkel Saving Mode?',
  whatIsDesc: 'enkel Saving Mode er en service med prisgaranti på opladning. Du sætter din afgangstid og ønskede batteriniveau – og du betaler altid for de billigste timer i din ladeperiode, uanset hvornår din bil rent faktisk lader. Du får også 0,10 kr./kWh laderabat ved opladning via appen. Kræver serviceaftale (inkluderet til 0 kr./md. ved ladeboks fra enkel).',
  saveUpTo: 'Spar på opladning',
  saveDesc: 'Du betaler altid for de billigste timer i din ladeperiode – det er din prisgaranti. Oveni får du 0,10 kr./kWh laderabat på opladning styret af Saving Mode. Kræver serviceaftale (inkluderet til 0 kr./md. ved ladeboks fra enkel).',
  fullyAutomatic: 'Helt automatisk',
  automaticDesc: 'Du behøver ikke tænke over noget. Sæt din afgangstid, og Saving Mode klarer resten.',
  alwaysReady: 'Altid klar når du skal bruge den',
  alwaysReadyDesc: 'Sæt en afgangstid, og Saving Mode sikrer din bil altid er opladet til netop det tidspunkt.',

  // How it works
  howItWorksTitle: 'Sådan fungerer Saving Mode',
  step1Title: 'Tilslut din ladeboks',
  step1Text: 'Forbind din ladeboks med enkel app. Vi understøtter Zaptec, NexBlue og Easee.',
  step2Title: 'Indstil afgangstid og batteriniveau',
  step2Text: 'Fortæl appen hvornår du skal bruge bilen og hvor meget strøm du har brug for.',
  step3Title: 'Lad appen klare resten',
  step3Text: 'Du betaler altid for de billigste timer i din ladeperiode, og din bil er klar til tiden. Du får også 0,10 kr./kWh laderabat automatisk (kræver serviceaftale – inkluderet til 0 kr./md.).',

  // Features
  featuresTitle: 'Funktioner i enkel app',
  feature1Title: 'Prisgaranti på opladning',
  feature1Desc: 'Du betaler altid for de billigste timer i din ladeperiode baseret på spotpriser',
  feature2Title: 'Fleksibel styring',
  feature2Desc: 'Sæt din afgangstid og ønskede batteriniveau – vi klarer resten',
  feature3Title: 'Altid klar til afgang',
  feature3Desc: 'Din bil er garanteret opladet til det tidspunkt du har valgt',
  feature4Title: 'Overblik i appen',
  feature4Desc: 'Se dit forbrug og dine tidligere opladninger i appen',
  feature5Title: 'Nem opsætning',
  feature5Desc: 'Tilføj din ladeboks i appen på 2 minutter – uden besværlig opsætning',
  feature6Title: 'Inkluderet',
  feature6Desc: 'Inkluderet i alle vores elaftaler uden ekstra omkostninger',

  // Compatible devices
  compatibleTitle: 'Virker med dit ladeudstyr',
  compatibleSubtitle: 'enkel Saving Mode understøtter de mest populære ladebokse på markedet',
  compatibleChargersTitle: 'Kompatible ladebokse',
  directIntegrationTitle: 'Kræver kompatibel ladeboks',
  directIntegrationDesc: 'Saving Mode virker via din ladeboks. Vi understøtter Zaptec, NexBlue og Easee.',
  contactIfUnsure: 'Kontakt os hvis du er i tvivl om din ladeboks er kompatibel.',
  andMore: '...',

  // Download
  downloadTitle: 'Download enkel app',
  downloadSubtitle: 'Inkluderet for alle vores kunder. Kom i gang med Saving Mode i dag.',

  // Cross-sell
  crossSellTitle: 'Kom i gang med enkel',
  crossSellSubtitle: 'Saving Mode er inkluderet med alle vores elaftaler',

  // Final CTA
  finalCtaTitle: 'Klar til at spare penge?',
  finalCtaSubtitle: 'Få en elaftale og få adgang til Saving Mode – inkluderet i prisen',
};